import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import TriggerApi from './TriggerApi';

export default function Wrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper Component={TriggerApi} {...props} />
  );
}
